export default {
  fullInput: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    padding: 3,
  },
  time: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    padding: 3,
  },
  timeInput: {
    // minWidth: 60,
    flex: 1,
  },
  dateInput: {
    // minWidth: 80,
    flex: 1,
  },
  input: {
    alignItems: 'center',
    padding: 3,
    flex: 1,
  },
  fixedInput: {
    alignItems: 'center',
    padding: 3,
  },
  row: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-end',
    paddingTop: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingBottom: 5,
    margin: 3,
  },
  quantity: {
    minWidth: 70,
    maxWidth: 100,
  },
  icon: {
    paddingTop: 30,
    paddingRight: 5,
  },
  role: {
    alignItems: 'center',
    flex: 1,
  },
};



// WEBPACK FOOTER //
// ./src/components/Resources/ResourceInput/styles.js